import React from 'react';
import { buildRenderGroups } from '../lib/sessionSupersets';
import SupersetBlock from './SupersetBlock';

// Lista esercizi CONDIVISA (scheda + libero): raggruppa per superserie di sessione,
// mostra "Sciogli" sui blocchi e, in modalità collegamento, un overlay di selezione
// sui singoli esercizi. La card del singolo esercizio è fornita da `renderCard`.
function SupersetList({ items, sessionSupersets, renderCard, linking }) {
  const groups = buildRenderGroups(items, sessionSupersets || []);

  return (
    <>
      {groups.map((g) => {
        if (g.type === 'superset') {
          return (
            <SupersetBlock
              key={g.group.id}
              group={g.group}
              exercises={g.exercises}
              renderCard={renderCard}
              onDissolve={() => linking.dissolve(g.group.id)}
              /* PB-011: recupero "tra i giri" editabile SOLO per le superserie
                 create live (id `ss-…`); quelle da scheda (`seed-…`) sono in sola
                 lettura in esecuzione (il valore persistente si modifica nel Builder). */
              restEditable={String(g.group.id).startsWith('ss-')}
              onSetRest={(sec) => linking.setGroupRest(g.group.id, sec)}
            />
          );
        }

        const ex = g.exercise;
        // In modalità collegamento: overlay selezionabile sui singoli (non i già-collegati)
        if (linking.linkMode) {
          const selected = linking.isSelected(ex.id);
          return (
            <div key={ex.id} className="relative">
              {renderCard(ex)}
              <button
                type="button"
                onClick={() => linking.toggle(ex.id)}
                className={`absolute inset-0 rounded-xl transition-colors flex items-start justify-end p-2 ${
                  selected
                    ? 'ring-4 ring-primary-500 bg-primary-500/10'
                    : 'ring-2 ring-dashed ring-gray-300 bg-white/50'
                }`}
              >
                <span
                  className={`text-xs font-bold px-2 py-1 rounded-full ${
                    selected ? 'bg-primary-500 text-white' : 'bg-gray-200 text-gray-600'
                  }`}
                >
                  {selected ? '✓ Selezionato' : 'Seleziona'}
                </span>
              </button>
            </div>
          );
        }

        return <div key={ex.id}>{renderCard(ex)}</div>;
      })}
    </>
  );
}

export default SupersetList;
